// src/pages/dashboard.js
import { useEffect, useState } from 'react';
import supabase from '../config/supabaseClient';
import '../components/dashboard.css';
import { useNavigate } from 'react-router-dom';
import { usePassport } from '../passport';
//import Friends from './friends.jsx';
import { lazy, Suspense } from 'react'; //Lazy loader to speed up transition when friends tab is pressed
import EventViewer from './eventviewer'; // ✅ Already in your code
import FriendsIcon from '../icons/friendsicon';
import AttendingIcon from '../icons/attendingicon';
import HostingIcon from '../icons/hostingicon';
import BuddyIcon from '../icons/buddyicon';
import DiceRollIcon from '../icons/dicerollicon';
import SettingsIcon from '../icons/settingsicon';


export default function Dashboard() {
  const Friends = lazy(() => import('./friends.jsx'));
  const [activeTab, setActiveTab] = useState(() => {
    return localStorage.getItem('lastActiveTab') || 'attending';
  });

  const { user: passportUser } = usePassport();
  const navigate = useNavigate();
  const [userEvents, setUserEvents] = useState([]);
  const events = [...userEvents];
  const [attendingEvents, setAttendingEvents] = useState([]);
  const [selectedEvent, setSelectedEvent] = useState(null);

 useEffect(() => {
  const fetchEvents = async () => {
    if (!passportUser) return;

    // Step 1: Fetch events owned by the user
    const { data: events, error } = await supabase
      .from('hosting')
      .select('*')
      .eq('user_id', passportUser.id);

    if (error) {
      console.error('Error fetching events:', error);
      return;
    }

    // Step 2: Get all host_ids (should just be one: current user)
    const hostIds = [...new Set(events.map(e => e.host_id).filter(Boolean))];

    const { data: profiles, error: profileError } = await supabase
      .from('profiles')
      .select('user_id, first_name, last_name')
      .in('user_id', hostIds);

    const profileMap = {};
    profiles?.forEach(p => {
      profileMap[p.user_id] = `${p.first_name} ${p.last_name}`;
    });

    const enriched = events.map(e => ({
      ...e,
      host_name: profileMap[e.host_id] || 'Unknown Host',
    }));

    const filtered = enriched.filter(e => e.event_name && e.event_image);
    setUserEvents(filtered);
  };

  fetchEvents();
}, [passportUser]);


      // Fetch events the user is attending (via guests table)
    useEffect(() => {
      fetchAttendingEvents();
    }, [passportUser]);

  useEffect(() => {
    // Clear selectedEvent when switching away from the Attending tab
    if (activeTab !== 'attending') {
      setSelectedEvent(null);
    }
  }, [activeTab]);

  // src/pages/dashboard.js
  const handleTabChange = (tab) => {
    // Always reset to grid when entering Attending
    if (tab === 'attending') {
      setSelectedEvent(null);
    }

    // Only flip tabs (and write to localStorage) if changing tabs
    if (tab !== activeTab) {
      setActiveTab(tab);
      localStorage.setItem('lastActiveTab', tab);
    }
  };


  const fetchAttendingEvents = async () => {
    if (!passportUser) return;

  const { data: guestEntries, error: guestError } = await supabase
    .from('guests')
    .select('event_id, status')
    .eq('guest_id', passportUser.id);


            console.log('👤 passportUser.id:', passportUser.id);
            console.log('🔍 guest entries:', guestEntries);

    if (guestError) {
      console.error('Error fetching guest entries:', guestError);
      return;
    }

    const eventIds = guestEntries.map(entry => entry.event_id);
    const statusMap = {};
        guestEntries.forEach(entry => {
        statusMap[entry.event_id] = entry.status || 'Pending';
    });
    if (eventIds.length === 0) {
      setAttendingEvents([]);
      return;
    }

    const { data: events, error: hostingError } = await supabase
      .from('hosting')
      .select('*')
      .in('id', eventIds);

    if (hostingError) {
      console.error('Error fetching events for guest entries:', hostingError);
      return;
    }

      // Fetch host names from profiles
      const hostIds = [...new Set(events.map(evt => evt.host_id).filter(Boolean))];
      const { data: hostsData, error: hostsError } = await supabase
        .from('profiles')
        .select('user_id, first_name, last_name')
        .in('user_id', hostIds);

      const hostMap = {};
      hostsData?.forEach(h => {
        hostMap[h.user_id] = `${h.first_name} ${h.last_name}`;
      });

      const eventsWithExtras = events.map(event => ({
        ...event,
        rsvp_status: statusMap[event.id] || 'Pending',
        host_name: hostMap[event.host_id] || 'Unknown Host',
      }));

      setAttendingEvents(eventsWithExtras);

  };


  return (
    <div className="dashboard-container">
      {/* Menu */}
      <div className="menu-wrapper">
                      <div className="menu-items">
                <span
                  className={`menu-item ${activeTab === 'cronies' ? 'cronies-active' : ''}`}
                  onClick={() => handleTabChange('cronies')}
                >
                  <FriendsIcon size={28} />
                </span>

                <span
                  className={`menu-item ${activeTab === 'attending' ? 'attending-active' : ''}`}
                  onClick={() => handleTabChange('attending')}
                >
                  <AttendingIcon size={28} />
                </span>

                <span
                  className={`menu-item ${activeTab === 'hosting' ? 'hosting-active' : ''}`}
                  onClick={() => handleTabChange('hosting')}
                >
                  <HostingIcon size={28} />
                </span>

                <span className="menu-item" onClick={() => alert('Buddy feature coming soon!')}>
                  <BuddyIcon size={28} />
                </span>

                <span className="menu-item" onClick={() => alert('Dice Roll feature coming soon!')}>
                  <DiceRollIcon size={28} />
                </span>


                <span
                  className={`menu-item ${activeTab === 'settings' ? 'settings-active' : ''}`}
                  onClick={() => navigate('/settings')}>
                
                  <SettingsIcon size={28} />
                </span>
                
              </div>

        <div className="menu-underline" />
      </div>

      {/* Parallax Content */}
      <div className="tab-scroll-wrapper">
        <div className="tab-content">
        {activeTab === 'cronies' && (
          <div className="tab-panel">
            <Suspense fallback={null}>
              <Friends />
            </Suspense>
          </div>
        )}

                {activeTab === 'attending' && !selectedEvent && (
          <div className="tab-panel">
            {attendingEvents.length > 0 ? (
              <div className="event-grid">
                {attendingEvents.map((event, index) => (
                  <div
                    className="event-tile"
                    key={event.id || index}
                    onClick={() => setSelectedEvent(event)}
                    title="Click to view event"
                  >
                    <img
                      src={event.image || event.event_image}
                      alt={event.name || event.event_name}
                      className="event-image"
                    />
                  <div className="event-info">
                      <p className="event-name">{event.name || event.event_name}</p>
                      <p className="event-meta">Host: {event.host_name}</p>
                      <p className="event-meta">
                        {event.event_date
                          ? `Date: ${new Date(event.event_date).toLocaleDateString(undefined, {
                              weekday: 'short',
                              month: 'short',
                              day: 'numeric',
                            })}`
                          : 'Date TBA'}
                      </p>
                      <p className="event-meta">Status: {event.rsvp_status}</p>
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <p style={{ textAlign: 'center', marginTop: '40px', fontSize: '1.2rem' }}>
                You are not currently attending any events.
              </p>
            )}
          </div>
        )}


        {selectedEvent && (
          <div className="tab-panel">
            <div className="attending-viewer-wrapper">
        <EventViewer
          event={selectedEvent}
          setIsEditing={() => {}}
        />

            </div>
          </div>
        )}
  {activeTab === 'hosting' && (
  <div className="tab-panel">
    <div className="event-grid">
      {events.map((event, index) => (
        <div
          className="event-tile"
          key={event.id || index}
          onClick={() => navigate(`/event/${event.id}`)}
          title="Click to view event"
        >
          <img
            src={event.image || event.event_image}
            alt={event.name || event.event_name}
            className="event-image"
          />
          <div className="event-info">
            <p className="event-name">{event.name || event.event_name}</p>
            <p className="event-meta">
              {event.event_date
                ? `Date: ${new Date(event.event_date).toLocaleDateString(undefined, {
                    weekday: 'short',
                    month: 'short',
                    day: 'numeric',
                  })}`
                : 'Date TBA'}
            </p>
            <p className="event-meta">Status: Hosting</p>
          </div>
        </div>
      ))}

          {/* New Event Tile */}
          <div className="event-tile" onClick={() => navigate('/newevent')}>
            <div className="plus-icon">+</div>
            <p className="event-name">New Event</p>
          </div>
        </div>
      </div>
        )}
        </div> 
      </div> 
    </div> 
  );
}